import Marquee from "react-fast-marquee";

const ITEMS = [
  "Ongoing Bookkeeping",
  "Bookkeeping Cleanup",
  "Books Diagnostic + Action Plan",
  "Manchester, New Hampshire",
  "Remote Clients Welcome",
  "Reliable Financial Records",
];

export const BrandMarquee = () => (
  <div
    data-testid="brand-marquee"
    className="bg-navy-900 text-warm-neutral py-5 border-y border-warm-neutral/10"
  >
    <Marquee speed={32} gradient={false} autoFill>
      {ITEMS.map((item, i) => (
        <span key={i} className="flex items-center">
          <span className="font-body text-sm uppercase tracking-[0.25em] text-warm-neutral/75 px-8">
            {item}
          </span>
          <span className="text-warm-accent" aria-hidden="true">
            &bull;
          </span>
        </span>
      ))}
    </Marquee>
  </div>
);

export default BrandMarquee;
